import styled from "styled-components";

import { brand_orange, brand_orange_deep } from "../../constants/styles";

// Windowed numeric pager: always shows first, last, and the current page ±1,
// collapsing the gaps to an ellipsis. Gaps carry the boundary page in their
// value (`gap-<n>`) so each has a stable React key without an array index.
function pageWindow(page, pages) {
  const shown = new Set([1, pages, page, page - 1, page + 1]);
  const out = [];
  let prev = 0;
  for (let i = 1; i <= pages; i += 1) {
    if (!shown.has(i) || i < 1) continue;
    if (i - prev > 1) out.push(`gap-${prev}`);
    out.push(i);
    prev = i;
  }
  return out;
}

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 32px;
`;

const PageButton = styled.button`
  min-width: 38px;
  height: 38px;
  padding: 0 10px;
  border-radius: 10px;
  border: 1px solid
    ${({ $active }) => ($active ? brand_orange_deep : "#e5e7eb")};
  background: ${({ $active }) => ($active ? brand_orange_deep : "#fff")};
  color: ${({ $active }) => ($active ? "#fff" : "#374151")};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 150ms ease,
    color 150ms ease,
    border-color 150ms ease,
    transform 100ms ease;

  &:hover:not(:disabled) {
    border-color: ${brand_orange_deep};
    color: ${({ $active }) => ($active ? "#fff" : brand_orange_deep)};
  }
  &:active:not(:disabled) {
    transform: scale(0.96);
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  &:focus-visible {
    outline: 2px solid ${brand_orange};
    outline-offset: 2px;
  }

  [data-theme="dark"] & {
    background: ${({ $active }) => ($active ? brand_orange_deep : "#17171e")};
    border-color: ${({ $active }) =>
      $active ? brand_orange_deep : "rgba(255,255,255,0.12)"};
    color: ${({ $active }) => ($active ? "#fff" : "#e5e7eb")};
  }
`;

const Ellipsis = styled.span`
  min-width: 24px;
  text-align: center;
  color: #9ca3af;
  font-weight: 700;
`;

export default function Pager({ page, pages, onChange }) {
  if (!pages || pages <= 1) return null;

  const items = pageWindow(page, pages);

  return (
    <Nav role="navigation" aria-label="Navigasi halaman">
      <PageButton
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        aria-label="Halaman sebelumnya"
      >
        ‹
      </PageButton>
      {items.map((it) =>
        typeof it === "string" ? (
          <Ellipsis key={it} aria-hidden="true">
            …
          </Ellipsis>
        ) : (
          <PageButton
            key={it}
            type="button"
            $active={it === page}
            aria-current={it === page ? "page" : undefined}
            aria-label={`Halaman ${it}`}
            onClick={() => onChange(it)}
          >
            {it}
          </PageButton>
        ),
      )}
      <PageButton
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= pages}
        aria-label="Halaman berikutnya"
      >
        ›
      </PageButton>
    </Nav>
  );
}
